jQuery(document).ready(function () {

	



	jQuery('body').on('click','.product-ajax-loadmore',function(event){
		var jthis = jQuery(this);
		jthis.addClass('loading');
		var new_url = jQuery(this).siblings('.pagination-wrapper').find('.pagination__item--current').parent().next().find('a').attr('href');
		jQuery.ajax(
            {
                url:new_url,
                type:'GET',
                dataType:'html'
            }
        ).done(function(new_page){
            var products = jQuery(new_page).find('.collection__items').html();
			var more = jQuery(new_page).find('.collection__items-loadmore').html();
			jQuery('.collection__items').append(products);
			jQuery('.collection__items-loadmore').html(more);
			// jthis.removeClass('loading');
        });
    });

	jQuery('.customizing-btn').click(function () {
        jQuery('.customize-box').addClass('active');
    });

	jQuery('.icon-slider_left').click(function () {
		if(!jQuery(this).hasClass('disabled')){
			jQuery(this).parents('.customize__item').hide();
			jQuery(this).parents('.customize__item').prev().fadeIn();
		}
    });
	jQuery('.icon-slider_right').click(function () {
		if(!jQuery(this).hasClass('disabled')){
			jQuery(this).parents('.customize__item').hide();
			jQuery(this).parents('.customize__item').next().fadeIn();
			if(jQuery(this).parents('.customize__item').hasClass('c-step-5')){
            //if(jQuery(this).parents('.customize__item').hasClass('c-step-4')){
				var ete = jQuery('.c-step-1 input[name="properties[Front to Back]"]').val(),
					ftb = jQuery('.c-step-1 input[name="properties[Temple to Temple]"]').val(),
					af = jQuery('.c-step-1 input[name="properties[Circumference]"]').val(),
					step_2_val_1 = jQuery('.c-step-2 input:checked').siblings().find('span').text(),
					step_2_val_2 = jQuery('.c-step-2 input:checked').siblings().find('p').text(),
					step_3_val_1 = jQuery('.c-step-3 input:checked').siblings().find('h4').text(),
					step_3_val_2 = jQuery('.c-step-3 input:checked').siblings().find('p').text(),
					images = jQuery('.c-step-5 input[name="properties[Images]"]')[0].files;
					
				jQuery('.c-step-6').find('.ete').text(ete);
				jQuery('.c-step-6').find('.ftb').text(ftb);
				jQuery('.c-step-6').find('.af').text(af);
				jQuery('.c-step-6').find('.step-2-value').find('p').text(step_2_val_1);
				jQuery('.c-step-6').find('.step-2-value').find('span').text(step_2_val_2);
				jQuery('.c-step-6').find('.step-3-value').find('p').text(step_3_val_1);
				jQuery('.c-step-6').find('.step-3-value').find('span').text(step_3_val_2);
				
				jQuery('.c-step-6').find('.step-4-value').html('');
				if(jQuery('.c-step-4 input:checked').length){
					jQuery('.c-step-4 .select-style__input').each(function () {
						var step_4_val_1 = jQuery(this).find('input:checked').siblings().text(),
							step_4_val_2 = jQuery(this).find('input:checked').parent().siblings().find('.price').text();
							jQuery('.c-step-5').find('.step-4-value').append('<div><h4>'+step_4_val_1+'</h4><p>'+step_4_val_2+'</p></div>');
					});
				}else{
					jQuery('.c-step-6').find('.step-4-value').html('<h4>None</h4>');
				}
				
				if(jQuery('.c-step-4 input:checked').length){
					var addon = '';
					jQuery('.c-step-4 input:checked').each(function (i) {
						if(i>0){
							addon = addon + ' + ' + jQuery(this).siblings().text();
						}else{
							addon = addon + jQuery(this).siblings().text();
						}
					});
				}else{
					var addon = 'None';
				}

				if(images.length){
					var names = '';
					
					for (var file in images){
						if(images[file].size){
						  names += '<div>'+ images[file].name +'</div>'
						}
					  }
					  jQuery('.c-step-6').find('.step-5-value').html(names)
				}else{
					jQuery('.c-step-6').find('.step-5-value').html('None')
				}

				var price = $('.product-details__info-title .price').text();
				if(jQuery('.product-variants-box .product-variant').length > 1){
                    jQuery('.product-variants-box .product-variant').each(function () {
    					var myaddon = jQuery(this).attr('data-name');
    					if(addon == myaddon){
    						price = jQuery(this).attr('data-price');
    						jQuery(this).addClass('active');
    					}else{
    						jQuery(this).removeClass('active');
    					}
    				});
                }

				jQuery('.c-step-6 .select-style__item-btn').find('span').text(price);
				
				
				
			}
		}
    });
	
	jQuery('.c-step-1 input').each(function () {
		if(jQuery(this).val()==''){
			jQuery(this).parents('.step-item').addClass('error-field').addClass('empty-field');
		}else{
			jQuery(this).parents('.step-item').removeClass('error-field').removeClass('empty-field');
		}
		if(!jQuery('.c-step-1').find('.error-field').length && !jQuery('.c-step-1').find('.empty-field').length ){
			jQuery('.c-step-1 .icon-slider_right').removeClass('disabled');
		}else{
			jQuery('.c-step-1 .icon-slider_right').addClass('disabled');
		}
	});
	jQuery('.c-step-1 input').keyup(function () {
		if(jQuery(this).val()==''){
			jQuery(this).parents('.step-item').addClass('error-field').addClass('empty-field');
		}else{
			jQuery(this).parents('.step-item').removeClass('error-field').removeClass('empty-field');
		}
		if(!jQuery('.c-step-1').find('.error-field').length && !jQuery('.c-step-1').find('.empty-field').length ){
			jQuery('.c-step-1 .icon-slider_right').removeClass('disabled');
		}else{
			jQuery('.c-step-1 .icon-slider_right').addClass('disabled');
		}
    });
	
	if(jQuery('.c-step-2 input:checked').length){
		jQuery('.c-step-2 .icon-slider_right').removeClass('disabled');
	}
	jQuery('.c-step-2 input').click(function () {
		jQuery('.c-step-2 .icon-slider_right').removeClass('disabled');
	});
	
	if(jQuery('.c-step-3 input:checked').length){
		jQuery('.c-step-3 .icon-slider_right').removeClass('disabled');
	}
	jQuery('.c-step-3 input').click(function () {
		jQuery('.c-step-3 .icon-slider_right').removeClass('disabled');
	});
	

	
	
	jQuery('.ajax-add-to-cart-btn').click(function (event) {
		event.stopPropagation();
		
		var ete = jQuery('.c-step-1 input[name="ete"]').val(),
			ftb = jQuery('.c-step-1 input[name="ftb"]').val(),
			af = jQuery('.c-step-1 input[name="af"]').val(),
			step_2_val_1 = jQuery('.c-step-2 input:checked').siblings().find('span').text(),
			step_3_val_1 = jQuery('.c-step-3 input:checked').siblings().find('h4').text();
		
		var id = jQuery('.product-variants-box .product-variant.active').attr('data-id');
		var quantity = 1;
		// let formData = {
		// 	'items': [{
		// 		'id': id,
		// 		'quantity': quantity,
		// 		"properties" : {
		// 			"Ear to Ear": ete,
		// 			"Front to Back": ftb,
		// 			"Across Forehead": af,
		// 			"Wig Grip": step_2_val_1,
		// 			"Baby Hairs": step_3_val_1
		// 		}
		// 	}]
		// };
		let formData = new FormData($('.customize__items')[0])
		formData.append('id', id)
		formData.append('quantity', quantity)

		// jQuery.ajax({
		// 	url:'/cart/add.js',
		// 	type: 'post',
		// 	dataType: 'json',
		// 	data: formData,
		// 	success: function(msg) {
		// 		jQuery.getJSON('/cart.js', function(cart) {
		// 			window.location.href = "/cart";
		// 		});
		// 	}
		// });

		$('.add-to-cart').addClass('loading')

		$.ajax({
			url : '/cart/add',
			type: 'POST',
			contentType: false,
			data: formData,
			cache : false,
			processData: false,
			error : function(err){
				$('.add-to-cart').removeClass('loading')
				alert('Error adding item to cart')
			}
		}).done(function(response) {
			window.location.href = "/cart";
		});
	});
  

}).on('click', function(event){
	console.log(event.target)
});

function displaySelectedFiles(elm) {
	var names = '';
	for (var file in elm.files){
	  if(elm.files[file].size){
		names += '<strong>'+ elm.files[file].name +'</strong>'
	  }
	}
	if(names){
	  elm.closest('.cform-files').querySelector('.cform-files-names').innerHTML = names;
	  elm.closest('.cform-files').querySelector('.cform-files-selected').classList.add('active')
	}
  }
  
  function clearFileInput(event, elm) {
	event.preventDefault()
	elm.closest('.cform-files').querySelector('input').value = '';
	elm.closest('.cform-files').querySelector('.cform-files-names').innerHTML = '';
	elm.closest('.cform-files').querySelector('.cform-files-selected').classList.remove('active')
	
  }

  
  document.addEventListener("click", function(event) {

	document.querySelectorAll('.cform-dropdown').forEach(function(elm){
	  if(elm.closest(".cform-dropdown") !== event.target.closest(".cform-dropdown")){
		elm.classList.remove('open')
	  }
	});
  
	if(event.target.classList.contains('cform-dropdown-list-item')){
	  var value = event.target.innerText;
	  event.target.closest(".cform-dropdown-list").querySelectorAll('.cform-dropdown-list-item').forEach(function(elm){
		elm.classList.remove('selected')
	  });
	  event.target.classList.add('selected');
	  event.target.closest(".cform-dropdown").querySelector('input').value = value;
	  event.target.closest(".cform-dropdown").querySelector('.cform-dropdown-value span').innerText = value;
	  event.target.closest(".cform-dropdown").classList.remove('open')
	}
  })